import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';

import { Observable } from 'rxjs';

import { VersionDTO } from '@api';
import { PermissionHelperService, SpaRoute } from '@permission';
import { StoreService } from '@state';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'spa-settings-menu',
  templateUrl: './settings-menu.component.html',
  styleUrls: ['./settings-menu.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsMenuComponent implements OnInit {
  private storeService = inject(StoreService);
  private readonly permissionHelperService = inject(PermissionHelperService);

  routes = input<SpaRoute[]>([]);

  filteredRoutes = signal<SpaRoute[]>([]);
  serverVersionInfo$: Observable<VersionDTO | undefined> = this.storeService.select('serverVersionInfo');

  get appVersion() {
    if (environment.version === '$$$BUILD_VERSION$$$') {
      return 'DEV';
    }
    return environment.version;
  }

  ngOnInit() {
    this.filteredRoutes.set(this.permissionHelperService.filterPermittedRoutes(this.routes(), ['**']));
  }
}
